export const isSectionInView = (section, startPercentage, endPercentage) => {
    const boundingRect = section.getBoundingClientRect();
    const top = boundingRect.top;
    const sectionHeight = boundingRect.height;
    const viewportHeight = window.innerHeight;

    if (top < 0) {
        return (
            sectionHeight + top >= (viewportHeight / 100) * startPercentage &&
            sectionHeight + top <= (viewportHeight / 100) * endPercentage
        );
    } else {
        return (
            top >= (viewportHeight / 100) * startPercentage &&
            top <= (viewportHeight / 100) * endPercentage
        );
    }
};
